const ACCESS_TOKEN_KEY = 'optimo_access_token';
const REFRESH_TOKEN_KEY = 'optimo_refresh_token';
const ID_TOKEN_KEY = 'optimo_id_token';
const TIME_SKEW_KEY = 'optimo_time_skew';

const parseTimeSkew = (value: string | null): number | null => {
  if (value === null) return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getPersistedTokens = (): {
  token: string | null;
  refreshToken: string | null;
  idToken: string | null;
  timeSkew: number | null;
} => ({
  token: localStorage.getItem(ACCESS_TOKEN_KEY),
  refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY),
  idToken: localStorage.getItem(ID_TOKEN_KEY),
  timeSkew: parseTimeSkew(localStorage.getItem(TIME_SKEW_KEY)),
});

export const persistTokens = (token: string, refreshToken: string, idToken: string, timeSkew: number): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  localStorage.setItem(ID_TOKEN_KEY, idToken);
  localStorage.setItem(TIME_SKEW_KEY, timeSkew.toString());
};

export const clearPersistedTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(TIME_SKEW_KEY);
};
